import React, { ReactNode } from 'react';
import { Paper, Link, TablePagination } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import MaterialTable from 'material-table';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import { useLanguageContext } from '../languages';
import { useIntl } from 'react-intl';
import DateCell from '../common/DateCell';
import { getLocalTimezone } from '../../utils/dateTransform';
import theme from '../../theme';
import { Airing } from '../../utils/types';
import commonMessages from '../common/messages';

dayjs.extend(isToday);

const AiringsList: React.FC<AiringsListProps> = (props) => {
	const { airings, pageSize, page, count, handleChangePage } = props;

	const intl = useIntl();
	const { tableLocalization } = useLanguageContext();

	const rowStyle = (rowData: Airing): CSSProperties =>
		dayjs(rowData.startTime ?? '').isToday() ? { backgroundColor: theme.palette.primary.main, color: 'white' } : {};

	return (
		<MaterialTable
			localization={tableLocalization}
			columns={[
				{
					title: 'ID',
					field: 'id',
					render: (row: Airing): JSX.Element => (
						<Link component={RouterLink} to={`/airings/${encodeURIComponent(row.id)}`} color='secondary'>
							{row.id}
						</Link>
					)
				},
				{
					title: 'Game Title (id)',
					field: 'game.title',
					render: (row: Airing): JSX.Element =>
						row.game ? (
							<Link component={RouterLink} to={`/games/${encodeURIComponent(row!.game!.id)}`} color='secondary'>
								{row!.game!.title} ({row!.game!.id})
							</Link>
						) : (
							<p>game not found</p>
						)
				},
				{ title: 'Status', field: 'status' },
				{
					title: `Start time (${getLocalTimezone()})`,
					field: 'startTime',
					render: (row: Airing): JSX.Element => <DateCell value={row.startTime} showInvalid={true} showTimezone={false} />
				},
				{ title: 'Business Logic', field: 'businessLogic' },
				{
					title: 'Highlight Count',
					field: 'highlights',
					render: (row: Airing): string => (row.highlights?.items ? row.highlights.items.length.toString() : '0')
				}
			]}
			data={airings}
			options={{ pageSize, search: false, sorting: false, rowStyle }}
			title='Airings'
			components={{
				Container: (props): JSX.Element => <Paper {...props} data-testid='airings-table' />,
				//Header: (): JSX.Element => (<AiringFilters setGraphQLFilters={updateFilters}/>),
				Pagination: ({ style }): JSX.Element => (
					<TablePagination
						style={style}
						rowsPerPageOptions={[pageSize]}
						rowsPerPage={pageSize}
						count={count}
						page={page}
						onPageChange={(e, page): void => handleChangePage(page)}
						labelDisplayedRows={({ from, to }): ReactNode =>
							intl.formatMessage(
								{
									...commonMessages.paginationLabel
								},
								{ from, to }
							)
						}
					/>
				)
			}}
		/>
	);
};

type AiringsListProps = {
	airings: Airing[];
	pageSize: number;
	page: number;
	count: number;
	handleChangePage: (page: number) => void;
};

export default AiringsList;
